import React, { useState } from 'react'
import { useLoading } from '../../components/loading/LoadingProvider'
import useUserInfo from '../../routers/useUserInfo'
import { getGiftsExChange } from '../../service'

const classnames = require('classnames')

type Props = {
    onSuccess: () => void
}

const DiscountInput: React.FC<Props> = (props) => {

    const [text, setText] = useState<string>('')
    const userData = useUserInfo(false)
    const loading = useLoading()
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setText(event.target.value.replace(/\s/g, ''))
    }

    const handleClick = () => {
        // props.onSuccess()
        if (userData) {
            getGiftsExChange({
                userId: userData.id,
                code: text
            }).then((res) => {
                if (res.code === 1) {
                    loading.showSuccess('兑换成功')
                    props.onSuccess()
                } else {
                    loading.showError(res.msg)
                }
            }).catch(e => {
                loading.showError('兑换失败')
            })
        }
    }

    return <div className="dis-input">
        <input type="text" placeholder="请输入兑换码" value={text} onChange={handleChange} />
        <div className={classnames("_btn", { 'active': text.length > 4 && text.length < 10 })} onClick={handleClick} >立即兑换</div>
    </div>
}

export default React.memo(DiscountInput)